import { render, staticRenderFns } from "./CategoryManage.vue?vue&type=template&id=35e3cc14&scoped=true"
import script from "./CategoryManage.vue?vue&type=script&lang=js"
export * from "./CategoryManage.vue?vue&type=script&lang=js"
import style0 from "./CategoryManage.vue?vue&type=style&index=0&id=35e3cc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3cc14",
  null
  
)

export default component.exports